import { Link } from "@inertiajs/react";
import { motion } from "motion/react";
import { Heart } from "lucide-react";

import { ProductImage } from "./ProductImage";
import { ProductPrice } from "./ProductPrice";
import { ProductRating } from "./ProductRating";
import { useWishlist } from "@/theme1/hooks/useWishlist";

export function ProductCard({ product }) {
  const { isWishlisted, toggleWishlist } = useWishlist();

  const wished = isWishlisted(product.slug);

  const handleWishlistClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleWishlist(product);
  };

  return (
    <motion.article
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.45 }}
      whileHover={{ y: -6 }}
      className="group rounded-[2rem] bg-white p-2 transition-shadow duration-300 hover:shadow-2xl hover:shadow-neutral-950/10"
    >
      {/* Make the entire card clickable */}
      <Link href={`/products/${product.slug}`} className="block">
        <div className="relative overflow-hidden rounded-[1.5rem]">
          <ProductImage product={product} />

          <motion.button
            type="button"
            onClick={handleWishlistClick}
            whileTap={{ scale: 0.82 }}
            whileHover={{ scale: 1.08 }}
            aria-label={wished ? "Remove from wishlist" : "Add to wishlist"}
            className="absolute right-4 top-4 z-20 flex size-11 items-center justify-center rounded-full bg-white/90 text-neutral-900 shadow-xl shadow-black/10 backdrop-blur-xl transition hover:bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            <Heart
              className={`size-5 transition ${
                wished ? "fill-red-600 text-red-600" : "text-neutral-800"
              }`}
            />
          </motion.button>
        </div>

        <div className="px-2 pb-3 pt-4">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-400">
            {product.series}
          </p>

          <h3 className="mt-2 line-clamp-2 text-sm font-semibold tracking-tight text-neutral-950 md:text-base hover:text-neutral-700 transition-colors">
            {product.title}
          </h3>

          <ProductRating rating={product.rating} reviews={product.reviews} />

          <ProductPrice
            price={product.price}
            comparePrice={product.comparePrice || product.compareAtPrice}
            discount={product.discount}
          />
        </div>
      </Link>
    </motion.article>
  );
}